import { AuthProvider } from 'react-oidc-context';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter } from 'react-router-dom';
import { oidcConfig } from '@/config/authConfig';
import { store, persistor } from '@/shared/store/Store';
import { SignalRProvider } from '@/context/SignalRProvider';
import { ErrorBoundary } from '@/components/app/ErrorBoundary';
import { AppErrorFallback } from '@/components/app/AppErrorFallback';
import { AppBootstrapLoader } from '@/components/app/AppBootstrapLoader';
import AppRoutes from '@/AppRoutes';

export default function App() {
  return (
    <ErrorBoundary fallback={<AppErrorFallback />}>
      <AuthProvider
        {...oidcConfig}
        skipSigninCallback={window.location.pathname === '/auth/callback'}
      >
        <ReduxProvider store={store}>
          <PersistGate persistor={persistor} loading={<AppBootstrapLoader />}>
            <SignalRProvider>
              <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                <AppRoutes />
              </BrowserRouter>
            </SignalRProvider>
          </PersistGate>
        </ReduxProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}
